export default __webpack_public_path__ + "static/agency-hotels-470b7bb9f18cb99755808c75a6ee4b75.png";